<script lang="ts">
  type Tone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral' | 'verde' | 'amarillo' | 'rojo' | 'gris' | 'total';

  let {
    label,
    value,
    hint = '',
    tone = 'brand' as Tone,
  }: {
    label: string;
    value: string | number;
    hint?: string;
    tone?: Tone;
  } = $props();
</script>

<div class="kpi {tone}">
  <span class="lbl">{label}</span>
  <strong class="val">{value}</strong>
  {#if hint}<small>{hint}</small>{/if}
</div>

<style>
  .kpi {
    padding: 1rem 1.1rem;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    background: var(--bg-elevated);
    box-shadow: var(--shadow-sm);
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-height: 5.5rem;
  }
  .lbl { font-size: 0.82rem; color: var(--text-secondary); font-weight: 500; }
  .val { font-size: 1.75rem; line-height: 1.1; color: var(--text-primary); }
  small { font-size: 0.75rem; color: var(--text-secondary); }
  .brand .val { color: var(--brand-deep); }
  .success, .verde { border-color: color-mix(in srgb, var(--success) 35%, var(--border)); }
  .success .val, .verde .val { color: var(--success); }
  .warning, .amarillo { border-color: color-mix(in srgb, var(--warning) 35%, var(--border)); }
  .danger, .rojo { border-color: color-mix(in srgb, var(--danger) 35%, var(--border)); }
  .danger .val, .rojo .val { color: var(--danger); }
  .total { background: linear-gradient(135deg, var(--brand-deep), var(--brand-strong)); border: 0; }
  .total .lbl, .total .val, .total small { color: #fff; }
  .gris .val { color: var(--text-secondary); }
  .neutral .val { color: var(--text-primary); }
</style>
